import script from "./title.widget.vue?vue&type=script&lang=ts&setup=true"
export * from "./title.widget.vue?vue&type=script&lang=ts&setup=true"

import "./title.widget.vue?vue&type=style&index=0&id=98ff67fc&lang=scss"

const __exports__ = script;

export default __exports__